<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        Edit {{ form.changed_key }}
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.usn_id"
              label="USN"
              outlined
              dense
              :items="[1, 2]"
              hide-details="auto"
              readonly
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.name"
              label="Name"
              outlined
              dense
              :items="[1, 2]"
              hide-details="auto"
              readonly
          /></v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="form.changed_key"
              :items="options_to_display"
              outlined
              dense
              hide-details="auto"
              label="Field to update*"
              :rules="[rules.required]"
              @change="updateType"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" v-if="form.changed_key == 'Amount'"
            ><v-text-field
              v-model.trim="form.amount"
              label="Existing Amount"
              outlined
              dense
              hide-details="auto"
              readonly
          /></v-col>
          <v-col cols="4" v-if="form.changed_key == 'Amount'"
            ><v-text-field
              v-model.trim="form.updated_value"
              label="Amount to be changed*"
              outlined
              dense
              :rules="[rules.required, rules.float]"
              hide-details="auto"
          /></v-col>
          <v-col cols="4" v-if="form.changed_key == 'Type'">
            <v-text-field
              v-model="form.type"
              outlined
              dense
              hide-details="auto"
              label="Existing Type"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="4" v-if="form.changed_key == 'Type'"
            ><v-text-field
              v-model.trim="form.updated_value"
              label="Type to be changed"
              outlined
              dense
              readonly
              hide-details="auto"
              append-icon=""
          /></v-col>
          <v-col cols="4" v-if="form.changed_key == 'Due Date'">
            <v-text-field
              v-model="form.to_date"
              outlined
              dense
              hide-details="auto"
              label="Existing Due Date"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="4" v-if="form.changed_key == 'Due Date'">
            <v-menu
              v-model="showDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Due Date to be changed*"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.updated_value"
                :min="minStartDate"
                @input="showDatePicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.remarks"
              class="mt-2"
              rows="2"
              dense
              label="Remarks"
              outlined
              :rules="[rules.required]"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">Save</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    invoice: {
      type: Object,
      default: () => {},
    },
    options_to_display: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      rules,
      form: {},
      feeTypes: ["Term Fee", "Annual"],
      showDatePicker: false,
    };
  },
  watch: {
    "form.updated_value"(val) {
      console.log("Updated date:", val);
    },
  },
  computed: {
    formattedDate() {
      if (!this.form.updated_value) return "";
      const [year, month, day] = this.form.updated_value.split("-");
      return `${day}-${month}-${year}`;
    },
    minStartDate() {
      return this.currentDate(new Date());
    },
  },
  created() {
    this.init();
  },
  methods: {
    currentDate(date) {
      const d = new Date(date);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    async init() {
      this.form = { ...this.invoice };
      console.log(this.form);
    },
    updateType() {
      if (this.form.changed_key == "Type") {
        this.form.updated_value = this.feeTypes.filter(
          (item) => item != this.form.type,
        )[0];
      } else if (this.form.changed_key === "Amount") {
        this.form.updated_value = null;
      } else if (this.form.changed_key === "Due Date") {
        delete this.form.updated_value;
      }
    },
    async save() {
      if (!this.$refs.form.validate()) return;
      const valueMap = {
        Amount: this.form.amount,
        Type: this.form.type,
        "Due Date": this.form.to_date,
      };

      const existing_value = valueMap[this.form.changed_key] ?? null;

      try {
        await this.$axios.put(`/update_academic_invoice`, {
          usn_id: this.form.usn_id,
          student_detail_id: this.form.student_detail_id,
          invoice_id: this.form.invoice_id,
          changed_key: this.form.changed_key,
          updated_value: this.form.updated_value,
          existing_value: existing_value,
          remarks: this.form.remarks,
        });
        this.$store.commit("showSnackbar", {
          message: "Updated Successfully",
          color: "success",
        });
        this.$emit("save");
      } catch (error) {
        const errorMessage = await this.$store.dispatch(
          "throwError",
          error.response,
        );
        this.$store.commit("showSnackbar", {
          message: errorMessage,
          color: "error",
        });
      }
    },
  },
};
</script>

<style scoped></style>
